var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    height: 200,
    viewBox: "0 0 250 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20125",
    "data-name": "Rectangle 20125",
    width: 214.322,
    height: 200,
    fill: "#d2d5da"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4132",
    "data-name": "Group 4132",
    transform: "translate(12842 21653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20121",
    "data-name": "Rectangle 20121",
    width: 250,
    height: 200,
    transform: "translate(-12842 -21653)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4131",
    "data-name": "Group 4131",
    transform: "translate(-12824.16 -21653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4130",
    "data-name": "Group 4130",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4925",
    "data-name": "Path 4925",
    d: "M89.615,32.67A16.335,16.335,0,1,0,73.28,16.335,16.335,16.335,0,0,0,89.615,32.67",
    transform: "translate(-40.783)",
    fill: "#d2d5da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4926",
    "data-name": "Path 4926",
    d: "M116.054,227.927a20.354,20.354,0,0,0-9.256,2.108L54.861,157.769a12.353,12.353,0,0,0,.483-5.577q-4.455-28.57-8.907-57.141-.633-4.057-1.265-8.113a7.692,7.692,0,0,0-3.7-5.125c-.266-.182-.413-.457-.709-.614a10.179,10.179,0,0,0-1.686-.524,9.925,9.925,0,0,0-5.713-.444,8.575,8.575,0,0,0-1.071.541,7.944,7.944,0,0,0-4.669,3.871Q16.1,108.109,4.577,131.573l-3.266,6.651c-.035.072-.035.157-.068.229a9.151,9.151,0,0,0-.959,3.218c-.01.07-.032.134-.041.2a8.876,8.876,0,0,0-.243,1.2v90.864c0,12.358,19.206,12.379,19.206,0v-2.629a9.177,9.177,0,0,0,3.552.731c4.872,0,10.021-4.4,9.6-9.6q-2.875-35.631-5.75-71.262-.337-4.187-.675-8.372L32.5,129.527q1.531,9.828,3.064,19.657l1.265,8.113c.8,5.128,7.221,7.968,11.812,6.706a8.9,8.9,0,0,0,2.065-1.045l51.73,71.979c-.08.349-.358.657-.358,1.018,0,4.435,6.26,8.029,13.98,8.029s13.98-3.595,13.98-8.029-6.259-8.028-13.98-8.028",
    transform: "translate(0 -44.514)",
    fill: "#d2d5da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4927",
    "data-name": "Path 4927",
    d: "M359,141.583a16.335,16.335,0,1,0-20.562-10.53A16.335,16.335,0,0,0,359,141.583",
    transform: "translate(-187.912 -61.051)",
    fill: "#d2d5da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4928",
    "data-name": "Path 4928",
    d: "M357.154,291.178a9.3,9.3,0,0,0-.353-1.559,12.545,12.545,0,0,0-1.811-3.16,9.275,9.275,0,0,0-1.194-1.116,10.142,10.142,0,0,0-1.067-1L330.6,270.011l14.87-4.964,3.748-1.251c4.755-1.588,8.363-6.694,6.706-11.812a10.416,10.416,0,0,0-1.423-2.635,7.786,7.786,0,0,0-.168-1.958q-8.091-24.815-16.182-49.63-1.16-3.56-2.321-7.12c-.057-.176-.2-.313-.263-.485a8.649,8.649,0,0,0-1.341-2.472c-.105-.142-.18-.3-.292-.432a7.7,7.7,0,0,0-.574-.848A10.023,10.023,0,0,0,332,185.54a9.876,9.876,0,0,0-1.447-.916,9.58,9.58,0,0,0-1.106-.4,8.431,8.431,0,0,0-2.737-.513c-.159,0-.311.033-.47.039a7.836,7.836,0,0,0-2.22.187c-.265.086-.475.288-.732.4a10.658,10.658,0,0,0-1.3.7,10.541,10.541,0,0,0-1.467.913c-.238.18-.511.257-.739.46l-52.42,46.524-7.336,6.512c-3.769,3.345-3.666,10.215,0,13.58a9.829,9.829,0,0,0,13.58,0l40.74-36.159c.03.179-.017.344.022.524q2.324,10.728,4.648,21.457l-24.165,6.152-6.3,1.6a8.387,8.387,0,0,0-1.761.892,8.612,8.612,0,0,0-3.978,3.521c-.084.158-.08.325-.154.485a8.931,8.931,0,0,0-.814,6.914,10.276,10.276,0,0,0,1.129,2.107,9.352,9.352,0,0,0,.6,1.126,9.833,9.833,0,0,0,.921.861,10.341,10.341,0,0,0,1.76,1.645l29.178,18.9c-3.242,1.6-5.709,4.978-5.546,8.611a9.8,9.8,0,0,0,9.6,9.6l24.816.852,3.572.123a7.93,7.93,0,0,0,1.35-.265,9.953,9.953,0,0,0,1.557-.3,9.108,9.108,0,0,0,1.744-.826,9,9,0,0,0,1.727-1.176,9.851,9.851,0,0,0,.973-1.112,7.7,7.7,0,0,0,.941-1.074c.094-.178.09-.366.173-.546a8.573,8.573,0,0,0,.8-2.507c.056-.3.144-.6.171-.9a7.521,7.521,0,0,0,.17-.892,10.229,10.229,0,0,0-.33-1.459",
    transform: "translate(-143.163 -102.241)",
    fill: "#d2d5da"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProDefault);
export default __webpack_public_path__ + "static/media/pro-default.aecb13c8ac296d26f2d2deaf4534b346.svg";
export { ForwardRef as ReactComponent };